/**
 * The French -> Korean deck, built from data/korean-core.ts.
 *
 * Every card accepts the Hangul (main answer and `alt` forms) and, for each
 * of those, the Latin spellings from shared/romanize.ts — so the deck works
 * with or without a Korean keyboard. Only the standard romanisation of the
 * main answer is *shown* (as the hint under a revealed answer); the naive and
 * no-space variants are accepted silently, since listing them would clutter
 * the card without teaching anything.
 */
import { KOREAN_CORE } from "../data/korean-core";
import { romanizations } from "./romanize";
import type { Entry } from "./vocab";

export const KOREAN_FR: Entry[] = KOREAN_CORE.map((e) => {
  const hangul = [e.ko, ...e.alt];
  const latin = hangul.flatMap(romanizations);
  return {
    w: e.fr,
    a: [...new Set([...hangul, ...latin])],
    show: [romanizations(e.ko)[0]!, ...e.alt],
  };
});
